var _defs, _rect, _polygon, _polygon2, _polyline, _line, _g, _g2, _rect2, _rect3, _path, _line2, _line3, _line4, _path2, _line5, _line6, _path3, _line7, _line8, _line9, _path4, _path5, _line10, _line11, _line12, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "situation_2",
    "data-name": "situation 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000.41 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-17,.cls-18,.cls-5{fill:none;}.cls-2{fill:#d0d9d9;}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_181);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_157);}.cls-11,.cls-18,.cls-5,.cls-7,.cls-8,.cls-9{stroke:#000;}.cls-11,.cls-17,.cls-18,.cls-5,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-6{clip-path:url(#clip-path);}.cls-7{stroke-width:3px;fill:url(#D\xE9grad\xE9_sans_nom_22);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_22-2);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_22-3);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_42);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_42-2);}.cls-12{clip-path:url(#clip-path-2);}.cls-13{fill:#eee8e8;}.cls-14{fill:#efeded;}.cls-15{fill:#a89892;}.cls-16{fill:#f7f7f7;}.cls-17{stroke:#d04439;stroke-width:17px;}.cls-18{stroke-width:2px;}.cls-19{fill:#233e82;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_181",
    x1: 1500,
    x2: 1500,
    y2: 2888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdd1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b6baba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9b9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8c9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868a8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157",
    x1: 2771,
    x2: 2771,
    y2: 2888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2799,693s-188-7-212-6c-3-12-13-24-13-24s-60-2-69,2-17,20-17,20-106-6-142-8c-19-24-37-33-57-21s-29,32-55,82c-122,215-207,802-207,802l-29,25s-80-21-134-27-246-13-294-13-199,11-317,41-143,68-150,88,12,36,12,36-28,75,50,240,224,196,224,196l-30,423c16,33,72,73,72,73l55,21,795,24,109,35,60-39,54-844h37l176-50,38-78,1-25-11-6Zm-562.5,912.5h-40c8-23,33-105,58-205-2,26-11,164-11,164l19,24Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22",
    x1: 1950.23,
    y1: 2702,
    x2: 1950.23,
    y2: 650.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8adad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b8bcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#cfd3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#eaeeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf1f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-2",
    x1: 1442.88,
    y1: 2622.5,
    x2: 1442.88,
    y2: 2139.01,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-3",
    x1: 1494.37,
    y1: 2622.5,
    x2: 1494.37,
    y2: 2143.51,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_42",
    x1: 1669.73,
    y1: 2153.45,
    x2: 1669.73,
    y2: 1921.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8adad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b9bebe",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e5e9ea",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf1f2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_42-2",
    x1: 1619.5,
    y1: 1728.5,
    x2: 1619.5,
    y2: 1605.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_42"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.35,1413c3,54.31,32.76,81.59,87.2,84,0,0,143.91-5.88,185.64-5.35,0,0,153.54,2.68,181.36,3.21s51.89,1.61,84.53-31c14.44-16,16.58-53.5,16.58-53.5s23.54-581,22.47-599.18-16.59-47.08-18.73-61.52-5.35-64.73-5.35-64.73c-1.31-3.71-3.28-6.19-5.88-7.49v-5.35c4.69-.14,4.15-18.33-.53-18.19l-4.28-.54v-42.8c-.5-17.75-134.78-14-134.29,3.75C671.1,615,670,656,670,656c-4.27.72-7.61,1.91-8.56,4.28V674.2H641.65S625.07,665.1,624,664s-33.71-49.22-33.71-49.22c-7.8-8.51-16.56-14.73-27.82-15l-226.83-1.07c-33.17,0-54.76,26-60.45,59.92l-9.63,93.09s-20.87,44.4-22.47,51.36S262.35,1413,262.35,1413Zm86.13-735.6c-.22-17.64,9.95-26.94,27.28-30.5l168.52,1.61c14.86,3.41,23.34,12.48,23.54,28.89-1.1,11.52-6.2,17.87-13.91,20.86l-163.7,24.61c-16.24.4-24.38-5.26-30-12.84Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Situation 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 2187,
    width: 3000,
    height: 813
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 2245 2542 2245 3000 2888 3000 0 0 0 0 2245"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "3000 2888 2542 2245 2542 0 3000 0 3000 2888"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "0 2245 2542 2245 3000 2888"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2542.5,
    y1: 0.5,
    x2: 2541.5,
    y2: 2244.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "toilettes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2799,693s-188-7-212-6c-3-12-13-24-13-24s-60-2-69,2-17,20-17,20-106-6-142-8c-19-24-37-33-57-21s-29,32-55,82c-122,215-207,802-207,802l-29,25s-80-21-134-27-246-13-294-13-199,11-317,41-143,68-150,88,12,36,12,36-28,75,50,240,224,196,224,196l-30,423c16,33,72,73,72,73l55,21,795,24,109,35,60-39,54-844h37l176-50,38-78,1-25-11-6Zm-562.5,912.5h-40c8-23,33-105,58-205-2,26-11,164-11,164l19,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1389,2126s79.58,22.34,214,25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 1455.26,
    y1: 2139.01,
    x2: 1430.5,
    y2: 2622.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 1489.25,
    y1: 2143.51,
    x2: 1499.5,
    y2: 2622.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2004.5,2122.5c166-119,181-281,181-281"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2419.5,
    y1: 1772.5,
    x2: 2280.5,
    y2: 2666.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "2744.5 1659.5 2433.5 1750.5 2473.5 860.5 2791.54 826.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2799.5,692.5c-1,0-322,36-322,36l-127-19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2473.5,860.5l-115-23-38,883s30,25,113,30"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "2254.5 1408.5 2243.5 1564.5 2322.94 1663.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "2262.72 1588.51 2236.5 1605.5 2197.5 1605.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "2236 1606 2320 1720 2062.5 1719.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1997.5,1564.5l45,121s-171,73-477,65-422-87-422-87-42-36,5.5-58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1114.5,1690.5s71,72,439,82,476-14,489-21,24-25,20-43a31.85,31.85,0,0,0-20-23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2051,1690.25l12-4.25s25,22,62,18c28.69-3.1,46-25,66-82s82-278,92-344c0,0,54-276,61-357s18-181,0-244"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2063.5,1685.5s46-26,105-205,119-438,128-507,36-200,24-304c-4-40-43.4-4.18-43.4-4.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1175.81,1951.25s60.23,121.77,187,166.51,399.73,34.74,399.73,34.74,204.2,1,248-35,106.31-82.77,153.16-195.89"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1619.5,
    cy: 1667,
    rx: 340,
    ry: 61.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2073.82,1676.35s-18.32-112.85-47.32-139.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2097.76,1644s-14.26-61.52-34.26-95.52c-1-49,39.55-278.73,56-347,20-83,130-456,174-525"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M262.35,1414.08c3,54.31,32.76,81.59,87.2,84,0,0,143.91-5.88,185.64-5.35,0,0,153.54,2.68,181.36,3.21s51.89,1.6,84.53-31c14.44-16.05,16.58-53.5,16.58-53.5s23.54-581,22.47-599.18-16.59-47.08-18.73-61.52S816.05,686,816.05,686c-1.31-3.71-3.28-6.19-5.88-7.49v-5.35c4.69-.14,4.15-18.33-.53-18.19l-4.28-.54V611.6c-.5-17.75-134.78-14-134.29,3.75,0,.75-1.07,41.73-1.07,41.73-4.27.72-7.61,1.91-8.56,4.28v13.91H641.65s-16.58-9.1-17.65-10.17-33.71-49.22-33.71-49.22c-7.8-8.51-16.56-14.73-27.82-15l-226.83-1.07c-33.17,0-54.76,25.95-60.45,59.92l-9.63,93.09s-20.87,44.4-22.47,51.36S262.35,1414.08,262.35,1414.08Zm86.13-735.6c-.22-17.64,9.95-26.94,27.28-30.5l168.52,1.61c14.86,3.41,23.34,12.48,23.54,28.89-1.1,11.52-6.2,17.87-13.91,20.86L390.21,724c-16.24.4-24.38-5.26-30-12.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M830.5,752.3s11.23,32.64-28.89,32.64H243.09l23.54-214,340.25,20.33L662,675.8c59.32-3.22,122.95-8.15,148.19,2.14l13.91,5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M567.82,678.48S599.39,635.14,578,620.7,339.39,610,339.39,610c-29.61,4.67-46.87,21.28-53,48.68v19.8s71.69-12.84,74.36-13.91S567.82,678.48,567.82,678.48Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 349.55,
    y: 935.8,
    width: 402.31,
    height: 438.15,
    transform: "translate(1101.41 2309.76) rotate(-180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 485.7,
    y: 1150.46,
    width: 120.11,
    height: 120.11,
    transform: "translate(1787.63 1680.57) rotate(135)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M554.39,1220.59h51.82v-7.67h-23c0,2.26-7.3,2.26-7.3,0H554.39Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 583.18,
    y1: 1212.92,
    x2: 590.86,
    y2: 1197.56
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 579.34,
    y1: 1206.2,
    x2: 579.34,
    y2: 1182.21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 575.5,
    y1: 1209.08,
    x2: 567.83,
    y2: 1197.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M550.55,1175.49c-4.48,0-4.48,7.68,0,7.68l28.79,1.43v-7.19Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 578.22,
    y1: 1184.54,
    x2: 547.24,
    y2: 1180.04
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 511.21,
    y1: 1206.2,
    x2: 511.21,
    y2: 1182.21
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M540,1175.49c4.48,0,4.48,7.68,0,7.68l-28.79,1.43v-7.19Z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 512.33,
    y1: 1184.54,
    x2: 543.31,
    y2: 1180.04
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 516.01,
    y1: 1205.24,
    x2: 523.68,
    y2: 1189.88
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 508.33,
    y1: 1201.4,
    x2: 500.65,
    y2: 1189.88
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M494.89,1222.51h3.84q.09,2.87,3.84,2.88h21.11l1.92-2.88h2.88l1-3.84h2.88v-4.79h-2.88V1210h-7.68v-3.84s-15.35-1-17.27,2.88h-9.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M507.37,1217.71s4.8-1.92,5.76-5.75l8.63-2.88"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 529.44,
    y1: 1213.88,
    x2: 519.84,
    y2: 1213.88
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 529.44,
    y1: 1218.67,
    x2: 517.93,
    y2: 1218.67
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 525.6,
    y1: 1222.51,
    x2: 516.01,
    y2: 1222.51
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M413.9,1033.68V991.14h8v42.54Zm4,0V1026h10.21a8.94,8.94,0,0,0,6.12-1.92,6.81,6.81,0,0,0,2.16-5.37v-12.52a6.79,6.79,0,0,0-2.16-5.38,9,9,0,0,0-6.12-1.9H417.94v-7.73h10q8,0,12.39,4t4.37,11.24v12.06a16.38,16.38,0,0,1-1.87,8,12.86,12.86,0,0,1-5.61,5.35,20.2,20.2,0,0,1-9.31,1.92Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M452.64,1033.68V991.14h8v42.54Zm2.9-34.81v-7.73h25.6v7.73Zm0,17.55v-7.72h22.38v7.72Zm0,17.26V1026h25.6v7.72Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M483.77,998.87v-7.73H515v7.73Zm11.58,34.81V994.62h8v39.06Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M512.91,1033.68l16.27-42.54h5.09l16.26,42.54H541.9l-10.18-29.05-10.18,29.05Zm7.81-6.82v-7.72H543.1v7.72Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M555.8,1033.68V991.11h8v42.57Zm3.19-17.11v-7.73h14.8a3.69,3.69,0,0,0,3-1.37,5.69,5.69,0,0,0,1.16-3.63,5.57,5.57,0,0,0-1.13-3.63,3.7,3.7,0,0,0-3-1.37H559v-7.73h15.45a11.86,11.86,0,0,1,6.18,1.58,10.72,10.72,0,0,1,4.11,4.45,16,16,0,0,1,0,13.4,11,11,0,0,1-4.11,4.45,11.82,11.82,0,0,1-6.17,1.58Zm19.28,17.11-10.33-18.43,8.57-1.35L588,1033.68Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M589,998.87v-7.73h31.18v7.73Zm11.58,34.81V994.62h8v39.06Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M638.63,1010.36h24.92v7.43H638.63ZM655,1002.2V1026h-7.72V1002.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M466.23,1072.78V1050h2.25v22.79Zm2.16,0v-2.1h5.16a6.68,6.68,0,0,0,4.74-1.48,5.85,5.85,0,0,0,1.57-4.46V1058a5.85,5.85,0,0,0-1.57-4.46,6.68,6.68,0,0,0-4.74-1.48h-5.16V1050h5.06q4.37,0,6.52,2t2.15,6.13v6.45a9.63,9.63,0,0,1-1,4.54,6.21,6.21,0,0,1-2.89,2.72,11.28,11.28,0,0,1-4.83.91Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M493.64,1073a7,7,0,0,1-5.27-1.9,7.37,7.37,0,0,1-1.86-5.38v-1.84a8.12,8.12,0,0,1,1.79-5.62,6.47,6.47,0,0,1,5.06-2,6,6,0,0,1,4.76,2,8.26,8.26,0,0,1,1.68,5.54v1.86H488.05v-2h9.65v-.15a5.56,5.56,0,0,0-1.14-3.74,4,4,0,0,0-3.2-1.32,4.43,4.43,0,0,0-3.51,1.39,5.74,5.74,0,0,0-1.24,4v2.07a5.15,5.15,0,0,0,1.32,3.78,4.92,4.92,0,0,0,3.71,1.34,5.52,5.52,0,0,0,2.23-.47,6,6,0,0,0,2-1.33l1.54,1.47a8.63,8.63,0,0,1-2.7,1.8A7.81,7.81,0,0,1,493.64,1073Zm-.44-19.63-1.38-1.1,4.49-5.57,1.67,1.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M502.94,1058.45v-1.94h7.33v1.94Zm5.48,14.41a3.51,3.51,0,0,1-2.91-1.12,5,5,0,0,1-.9-3.19v-16.77h2.26v16.8a2.51,2.51,0,0,0,.47,1.61,1.7,1.7,0,0,0,1.39.57h1.54v2.1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M519.86,1073a6.68,6.68,0,0,1-4.42-1.31,4.61,4.61,0,0,1-1.56-3.72,4.48,4.48,0,0,1,1.44-3.56,5.94,5.94,0,0,1,4-1.26h5.41l.22,2.1h-5.61a3.67,3.67,0,0,0-2.43.71,2.5,2.5,0,0,0-.85,2,2.47,2.47,0,0,0,1.07,2.14,5.19,5.19,0,0,0,3,.76,10,10,0,0,0,3.26-.42c.77-.28,1.16-.68,1.16-1.19l.33,2.13a4.23,4.23,0,0,1-1.25.88,7.48,7.48,0,0,1-1.73.55A11.64,11.64,0,0,1,519.86,1073Zm4.77-.23v-10.31a4.25,4.25,0,0,0-1.06-3.07,4,4,0,0,0-3-1.09,7,7,0,0,0-2.26.38,6.67,6.67,0,0,0-2,1.06l-1.65-1.12a6.13,6.13,0,0,1,2.44-1.74,8.86,8.86,0,0,1,3.36-.61,6.62,6.62,0,0,1,4.74,1.58,5.86,5.86,0,0,1,1.67,4.47v10.45Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M531.74,1072.78v-16.27H534v16.27Zm9.58-13.35a3.26,3.26,0,0,0-1.26-.79,5.32,5.32,0,0,0-1.77-.26,4.36,4.36,0,0,0-3.17,1.09,4,4,0,0,0-1.12,3l-.33-3.13a6.37,6.37,0,0,1,5.52-3.07,5.81,5.81,0,0,1,2,.32,4.58,4.58,0,0,1,1.58.94Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M544.19,1058.45v-1.94h7.33v1.94Zm5.48,14.41a3.5,3.5,0,0,1-2.9-1.12,4.89,4.89,0,0,1-.91-3.19v-16.77h2.26v16.8a2.51,2.51,0,0,0,.47,1.61,1.72,1.72,0,0,0,1.4.57h1.53v2.1Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M555.91,1072.78v-16.27h2.26v16.27Zm9.58-13.35a3.26,3.26,0,0,0-1.26-.79,5.32,5.32,0,0,0-1.77-.26,4.34,4.34,0,0,0-3.17,1.09,4,4,0,0,0-1.12,3l-.33-3.13a6.34,6.34,0,0,1,5.52-3.07,5.81,5.81,0,0,1,2,.32,4.58,4.58,0,0,1,1.58.94Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M574.81,1073a6.68,6.68,0,0,1-4.42-1.31,4.61,4.61,0,0,1-1.56-3.72,4.48,4.48,0,0,1,1.44-3.56,5.94,5.94,0,0,1,4-1.26h5.41l.22,2.1h-5.61a3.62,3.62,0,0,0-2.42.71,2.71,2.71,0,0,0,.22,4.15,5.14,5.14,0,0,0,3,.76,10,10,0,0,0,3.26-.42c.77-.28,1.16-.68,1.16-1.19l.33,2.13a4.23,4.23,0,0,1-1.25.88,7.48,7.48,0,0,1-1.73.55A11.64,11.64,0,0,1,574.81,1073Zm4.77-.23v-10.31a4.21,4.21,0,0,0-1.06-3.07,4,4,0,0,0-3-1.09,7.05,7.05,0,0,0-2.26.38,6.67,6.67,0,0,0-2,1.06l-1.64-1.12a6,6,0,0,1,2.43-1.74,8.86,8.86,0,0,1,3.36-.61,6.62,6.62,0,0,1,4.74,1.58,5.82,5.82,0,0,1,1.67,4.47v10.45Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M586.69,1072.78v-16.27H589v16.27Zm10.82,0v-9.86a4.64,4.64,0,0,0-1.14-3.35,4.19,4.19,0,0,0-3.2-1.19,4.32,4.32,0,0,0-3.11,1,4,4,0,0,0-1.11,3l-.33-3.14A5.19,5.19,0,0,1,591,1057a7.58,7.58,0,0,1,3.22-.67,5,5,0,0,1,4.09,1.73,7.38,7.38,0,0,1,1.45,4.9v9.87Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M603.37,1058.45v-1.94h7.33v1.94Zm5.49,14.41a3.51,3.51,0,0,1-2.91-1.12,5,5,0,0,1-.9-3.19v-16.77h2.25v16.8a2.51,2.51,0,0,0,.47,1.61,1.72,1.72,0,0,0,1.4.57h1.53v2.1Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M805.36,653.33S726.71,643.7,670,656c-8-9.1.32-11.83.32-11.83,49.86-6.41,95.7-7.51,135,0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M810.17,677.41c-36.76-8.36-91.25-6.64-148.73-3.21v-2.84c42.65-4.21,85.47-8.31,148.73.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituation2);
export default __webpack_public_path__ + "static/media/situation_2.3ae32bd867281f3ab326ef929c059354.svg";
export { ForwardRef as ReactComponent };